module.exports = __webpack_public_path__ + "img/btn1.c007dd82.png";